// import React, { useState, useEffect } from "react";
// import { useForm } from "react-hook-form";
// import {
//   Modal,
//   Button,
//   RichTextEditor,
//   ErrorTextHelper,
//   FlashMessage,
// } from "../../../components/common";
// import { useDispatch } from "react-redux";
// import {
//   stripHTMLTags,
//   uuid,
//   dataURLtoBlob,
// } from "../../../utils/helper";
// import { editFeedRequest } from "../../../reducers/feeds/feedPost.reducer"
// import httpRequest from "../../../utils/httpRequest";
// import API_URLS from "../../../utils/apiUrls";

// interface PostMedia {
//   id: string;
//   media_thumbnail: string;
//   media_type: string;
//   media_original: string;
// }

// export interface MyDataType {
//   id: number;
//   content?: string;
//   schedule_at?: string;
//   timezone?: string;
//   post_media: PostMedia[];
// }
// interface Props {
//   post: MyDataType;                // from your ScheduleModel fetchedData
//   open: boolean;
//   onClose: () => void;
// }

// export default function EditScheduledPostModal({ post, open, onClose }: Props) {
//   const dispatch = useDispatch();
//   const [postMedia, setPostMedia] = useState(post.post_media);
//   const [updatedAssets, setUpdatedAssets] = useState<{id:string;file:Blob}[]>([]);
//   const [deleteMedia, setDeleteMedia] = useState<string[]>([]);
//   const [isSaveDisabled, setIsSaveDisabled] = useState(true);

//   const form = useForm<{ content: string }>({
//     defaultValues: { content: post.content || "" },
//   });
//   const { control, watch, handleSubmit, formState: { errors }, reset } = form;
//   const content = watch("content");
//  console.log("EditScheduledPostModal content", content);
//   // track length / changes
//   useEffect(() => {
//     const changed =
//       stripHTMLTags(content) !== stripHTMLTags(post.content || "") ||
//       postMedia.length !== post.post_media.length ||
//       updatedAssets.length > 0 ||
//       deleteMedia.length > 0;
//     setIsSaveDisabled(!changed);
//   }, [content, postMedia, updatedAssets, deleteMedia]);

//   // reset when the post prop changes
//   useEffect(() => {
//     reset({ content: post.content || "" });
//     setPostMedia(post.post_media);
//     setUpdatedAssets([]);
//     setDeleteMedia([]);
//   }, [post, reset]);

//   const onSubmit = (vals: { content: string }) => {
//     const payload = new FormData();
//     payload.append("id", String(post.id));
//     payload.append("post_text", content);

//     // append new assets
//     let idx = 1;
//     updatedAssets.forEach(({ id, file }) => {
//       payload.append(`post_media_${idx}`, file);
//       idx++;
//     });

//     // mark deletes
//     if (deleteMedia.length) {
//       payload.append("deleted_post_media", JSON.stringify(deleteMedia));
//     }
// const response= httpRequest()    .put(`${API_URLS.posts}/${post.id}`, payload)
//    console.log("EditScheduledPostModal response", response);

//     onClose();
//     FlashMessage("Scheduled post updated", "success");
//   };

//   // handlers for adding/removing media similar to FeedBodyHeader …

//   return (
//     <Modal
//       visible={open}
//       title="Edit Scheduled Post"
//       size="large"
//       closeButton
//       onClose={onClose}
//     >
//       <form onSubmit={handleSubmit(onSubmit)}>
//         <RichTextEditor
//           name="content"
//           control={control}
//           rules={{
//             validate: (v) =>
//               stripHTMLTags(v).length <= 3000 || "Max 3,000 characters",
//           }}
//           validationObj={errors}
//           useMention
//         />
//         {errors.content && (
//           <ErrorTextHelper text={errors.content.message} />
//         )}
//         {/* media preview + upload button here */}
//         <div style={{ marginTop: 16, textAlign: "right" }}>
//           <Button
//             type="submit"
//             disabled={isSaveDisabled}
//           >
//             Save
//           </Button>
//           <Button color="secondary" onClick={onClose} style={{ marginLeft: 8 }}>
//             Cancel
//           </Button>
//         </div>
//       </form>
//     </Modal>
//   );
// }

import React, { useState, useEffect } from "react";
import { useForm } from "react-hook-form";
import {
  Modal,
  Button,
  RichTextEditor,
  ErrorTextHelper,
  FlashMessage,
} from "../../../components/common";
import { stripHTMLTags, uuid } from "../../../utils/helper";
import httpRequest from "../../../utils/httpRequest";
import API_URLS from "../../../utils/apiUrls";
import FeedButton from "../FeedPost/component/FeedButton";
import cameraIcon from "../../../assets/svg/camera.svg";
import Image from "../../../components/common/Image";
import ReactPlayer from "react-player";
import { Cancel as CancelOut } from "@material-ui/icons";
import CommonVideoModal from "../../../components/common/CoverImage";
import FeedLogo from "../FeedPost/component/FeedLogo";

interface MediaAsset {
  id: string;
  media_type: "image" | "video";
  media_thumbnail: string;
  media_original: string;
  thumbnails?: string[];
  selectedCover?: string;
  loadingThumbnails?: boolean;
  thumbnailsGenerated?: boolean;
  thumbnailsCacheKey?: string;
  coverBlob?: Blob;
  isNewUpload?: boolean;
}

export interface MyDataType {
  id: string | number;
  content?: string;
  schedule_at?: string;
  timezone?: string;
  post_media: any[]; 
 }

interface Props {
  post: MyDataType;
  open: boolean;
  onClose: () => void;
  onUpdate?: (updatedPost: MyDataType) => void;
}

export default function EditScheduledPostModal({
  post,
  open,
  onClose,
  onUpdate,
}: Props) {
  const [loading, setLoading] = useState(false);
  const [postMedia, setPostMedia] = useState<MediaAsset[]>(() => {
    // Add debugging
    if (!post.post_media || !Array.isArray(post.post_media)) {
      return [];
    }

    return post.post_media.map((m: any) => ({
      id: m.id || uuid(),
      media_type: m.media_type || (m.type === "video" ? "video" : "image"),
      media_thumbnail: m.media_thumbnail || m.thumbnail || m.url,
      media_original: m.media_original || m.original || m.url,
      thumbnails: m.selectedCover
        ? [m.selectedCover]
        : [m.media_thumbnail || m.thumbnail],
      selectedCover: m.selectedCover || m.media_thumbnail || m.thumbnail,
      loadingThumbnails: false,
    }));
  });
 
  const [updatedAssets, setUpdatedAssets] = useState<
    { id: string; file: Blob }[]
  >([]);
  const [deleteMedia, setDeleteMedia] = useState<string[]>([]);
  const [isSaveDisabled, setIsSaveDisabled] = useState(true);
  const [postTextLength, setPostTextLength] = useState<number>(0);
  const [show, setShow] = useState(false);
  const [currentVideo, setCurrentVideo] = useState<any>(null);
  const [currentVideoIndex, setCurrentVideoIndex] = useState<number | null>(
    null
  );

  const form = useForm<{ content: string }>({
    defaultValues: { content: post.content || "" },
  });
  const {
    control,
    watch,
    handleSubmit,
    formState: { errors },
    reset,
  } = form;
  const content = watch("content");

  // Check content length
  useEffect(() => {
    const tmpText = stripHTMLTags(content);
    setPostTextLength(tmpText.length);
  }, [content]);

  // Track changes for save button state
  useEffect(() => {
    const isContentChanged =
      stripHTMLTags(content) !== stripHTMLTags(post.content || "");
    const isMediaChanged = postMedia.length !== (post.post_media?.length || 0);

    const hasRealCoverChanges = postMedia.some((asset) => {
      if (asset.media_type !== "video") return false;
      const originalAsset = post.post_media.find((m: any) => m.id === asset.id);
      if (!originalAsset) return false;
      return (
        asset.selectedCover &&
        asset.selectedCover !== originalAsset.media_thumbnail
      );
    });

    const hasNewMedia = updatedAssets.length > 0;
    const hasDeletedMedia = deleteMedia.length > 0;

    setIsSaveDisabled(
      !(
        isContentChanged ||
        isMediaChanged ||
        hasRealCoverChanges ||
        hasNewMedia ||
        hasDeletedMedia
      )
    );
  }, [
    content,
    postMedia,
    updatedAssets,
    deleteMedia,
    post.content,
    post.post_media,
  ]);

  // Reset when the post prop changes
  useEffect(() => {

    reset({ content: post.content || "" });

    if (!post.post_media || !Array.isArray(post.post_media)) {
      setPostMedia([]);
    } else {
      setPostMedia(
        post.post_media.map((m: any) => ({
          id: m.id || uuid(),
          media_type: m.media_type || (m.type === "video" ? "video" : "image"),
          media_thumbnail: m.media_thumbnail || m.thumbnail || m.url,
          media_original: m.media_original || m.original || m.url,
          thumbnails: [m.selectedCover || m.media_thumbnail || m.thumbnail],
          selectedCover: m.selectedCover || m.media_thumbnail || m.thumbnail,
          loadingThumbnails: false,
        }))
      );
    }

    setUpdatedAssets([]);
    setDeleteMedia([]);
  }, [post, reset]);

  const dataURLtoBlob = (dataURL: string): Blob => {
    const [header, b64] = dataURL.split(",");
    const mime = header.match(/:(.*?);/)![1];
    const binary = atob(b64);
    const len = binary.length;
    const u8 = new Uint8Array(len);
    for (let j = 0; j < len; j++) u8[j] = binary.charCodeAt(j);
    return new Blob([u8], { type: mime });
  };

    async function generateThumbnails(
    urlOrFile: string | File,
    count = 1,
    maxSizeKB = 15,
    maxWidth = 320
  ): Promise<string[]> {
    const targetBytes = maxSizeKB * 1024;
    const video = document.createElement("video");
    video.crossOrigin = "anonymous";
    video.preload = "auto";
    video.src =
      typeof urlOrFile === "string"
        ? urlOrFile
        : URL.createObjectURL(urlOrFile);

    // wait for metadata / error
    await new Promise<void>((res, rej) => {
      video.addEventListener("loadedmetadata", () => res(), { once: true });
      video.addEventListener("error", (e) => rej(e), { once: true });
      video.load();
    });

    if (video.duration < 2) {
      if (typeof urlOrFile !== "string") URL.revokeObjectURL(video.src);
      throw new Error("Video too short (must be >2s)");
    }

    // evenly-spaced snapshot times (skip first second)
    const interval = (video.duration - 2) / count;
    const captureTimes = Array.from(
      { length: count },
      (_, i) => 1 + i * interval
    );

    const canvas = document.createElement("canvas");
    const ctx = canvas.getContext("2d")!;
    const thumbs: string[] = [];

    // helper: render current frame and produce a JPEG blob @ quality q
    const toJpegBlob = (q: number) =>
      new Promise<Blob>((resolve) =>
        canvas.toBlob((b) => resolve(b!), "image/jpeg", q)
      );

    // for each timestamp, seek → draw → compress → dataURL
    for (let t of captureTimes) {
      // seek
      await new Promise<void>((res) => {
        const onSeek = () => {
          video.removeEventListener("seeked", onSeek);
          res();
        };
        video.addEventListener("seeked", onSeek);
        video.currentTime = t;
      });

      // scale to maxWidth
      const scale = Math.min(1, maxWidth / video.videoWidth);
      canvas.width = Math.floor(video.videoWidth * scale);
      canvas.height = Math.floor(video.videoHeight * scale);
      ctx.drawImage(video, 0, 0, canvas.width, canvas.height);

      // binary-search JPEG quality in [0,1] over ~8 iterations
      let low = 0,
        high = 1;
      let bestBlob = await toJpegBlob(high);

      for (let i = 0; i < 8; i++) {
        const mid = (low + high) / 2;
        const blob = await toJpegBlob(mid);
        if (blob.size > targetBytes) {
          high = mid;
        } else {
          low = mid;
          bestBlob = blob;
        }
      }

      // if still too big, downscale dimensions incrementally
      if (bestBlob.size > targetBytes) {
        let currW = canvas.width;
        while (bestBlob.size > targetBytes && currW > 50) {
          currW = Math.floor(currW * 0.8);
          const factor = currW / video.videoWidth;
          canvas.width = currW;
          canvas.height = Math.floor(video.videoHeight * factor);
          ctx.drawImage(video, 0, 0, canvas.width, canvas.height);
          bestBlob = await toJpegBlob(low);
        }
      }

      // blob → dataURL
      const dataUrl = await new Promise<string>((res, rej) => {
        const reader = new FileReader();
        reader.onload = () => res(reader.result as string);
        reader.onerror = () => rej("FileReader error");
        reader.readAsDataURL(bestBlob);
      });

      thumbs.push(dataUrl);
    }

    if (typeof urlOrFile !== "string") URL.revokeObjectURL(video.src);
    return thumbs;
  }
  const onSubmit = async (vals: { content: string }) => {
    setLoading(true);
    try {
      const payload = new FormData();
      payload.append("id", String(post.id));
      payload.append("post_text", content);

      // Handle newly added media files
      let mediaIndex = 1;
      updatedAssets.forEach(({ id, file }) => {
        payload.append(`post_media_${mediaIndex}`, file);

        const asset = postMedia.find((a) => a.id === id);
        // if (asset?.media_type === "video" && asset.coverBlob) {
        //   payload.append(
        //     `cover_media_${mediaIndex}`,
        //     asset.coverBlob,
        //     `cover_${id}.jpg`
        //   );
        // }
        if (asset?.media_type === "video" && asset.selectedCover) {
          const coverBlob = asset.selectedCover.startsWith("data:")
            ? dataURLtoBlob(asset.selectedCover)
            : null;
          if (coverBlob) {
            payload.append(`cover_media_${mediaIndex}`, coverBlob);
          }
        }
        mediaIndex++;
      });

      // Handle cover updates for existing videos
      postMedia.forEach((asset) => {
        if (
          asset.media_type !== "video" ||
          updatedAssets.some((a) => a.id === asset.id)
        )
          return;

        const originalAsset = post.post_media.find(
          (m: any) => m.id === asset.id
        );
        if (!originalAsset) return;

        if (
          asset.selectedCover?.startsWith("data:") &&
          asset.selectedCover !== originalAsset.selectedCover
        ) {
          const coverBlob = dataURLtoBlob(asset.selectedCover);
          const coverIndex = mediaIndex++;

          payload.append(
            `cover_media_${coverIndex}`,
            coverBlob,
            `cover_update_${asset.id}.jpg`
          );

          payload.append(`original_video_${asset.id}`, asset.media_original);
        }
      });

      // Mark deleted media
      if (deleteMedia.length) {
        payload.append("deleted_post_media", JSON.stringify(deleteMedia));
      }

      const response = await httpRequest().put(
        `${API_URLS.posts}/${post.id}`,
        payload
      );

      if (response.status !== 200) {
        throw new Error("Failed to update scheduled post");
      }

      const savedPost = response.data?.data;
      const updatedPostData: MyDataType = {
        ...post,
        ...savedPost,
        content: savedPost?.content ?? content,
        post_media: savedPost?.post_media ?? postMedia,
      };

      // Refresh the scheduled-post list only with the confirmed server result.
      onUpdate?.(updatedPostData);


      onClose();
      FlashMessage("Scheduled post updated successfully", "success");
    } catch (error) {
      FlashMessage("Failed to update scheduled post", "error");
    } finally {
      setLoading(false);
    }
  };

  const removeMedia = (media_id: string, i: number) => {
    const _data = (postMedia || []).filter((row) => row.id !== media_id);
    setPostMedia(_data);
    setDeleteMedia((data: string[]) => [...data, media_id]);
    setUpdatedAssets((prevState) => prevState.filter((r) => r.id !== media_id));
  };

  // const onUpdateMedia = async (e: React.ChangeEvent<HTMLInputElement>) => {
  //   const files = Array.from(e.target.files || []);
  //   if (!files.length) return;

  //   // Prevent >4 items
  //   if (postMedia.length + files.length > 4) {
  //     FlashMessage("Max 4 files can be uploaded", "error");
  //     e.target.value = "";
  //     return;
  //   }

  //   const newAssets: MediaAsset[] = [];
  //   for (const file of files) {
  //     const id = uuid();
  //     const url = URL.createObjectURL(file);
  //     const asset: MediaAsset = {
  //       id,
  //       media_type: file.type.startsWith("video/") ? "video" : "image",
  //       media_thumbnail: url,
  //       media_original: url,
  //       isNewUpload: true, // Add flag to identify new uploads
  //     };

      

  //     newAssets.push(asset);
  //     setUpdatedAssets((prev) => [...prev, { id, file }]);
  //   }

  //   setPostMedia((prev) => [...prev, ...newAssets]);
  //   e.target.value = "";
  // };

  const onUpdateMedia = async (e: React.ChangeEvent<HTMLInputElement>) => {
  const files = e.target.files;
  if (!files || files.length === 0) return;

  // Prevent >4 items
  if (postMedia.length + files.length > 4) {
    FlashMessage("Max 4 files can be uploaded", "error");
    e.target.value = "";
    return;
  }

  const newAssets: MediaAsset[] = [];
  
  for (let i = 0; i < files.length; i++) {
    const file = files[i];
    const fileType = file.type;
    const fileSize = file.size;
    const isVideo = fileType.startsWith("video/");
    
    // File size validation - 50MB for video, 25MB for image
    const allowFileSize = isVideo ? 50 * 1024 * 1024 : 25 * 1024 * 1024;
    
    if (fileSize > allowFileSize) {
      const mb = Math.floor(allowFileSize / 1024 / 1024);
      FlashMessage(`Max ${mb} MB file size allowed`, "error");
      continue;
    }

    const id = uuid();
    const url = URL.createObjectURL(file);
    
    const asset: MediaAsset = {
      id,
      media_type: isVideo ? "video" : "image",
      media_thumbnail: url,
      media_original: url,
      isNewUpload: true,
      loadingThumbnails: false,
      thumbnailsGenerated: false,
    };

    // Generate thumbnails for video files
    if (isVideo) {
      try {
        asset.loadingThumbnails = true;
        
        // Generate thumbnails using your existing function
        const thumbs = await generateThumbnails(file);
        
        asset.thumbnails = thumbs;
        asset.selectedCover = thumbs[0]; // Set first thumbnail as default cover
        asset.media_thumbnail = thumbs[0]; // Update thumbnail to show generated cover
        asset.loadingThumbnails = false;
        asset.thumbnailsGenerated = true;
        
        // Convert the first thumbnail to blob for submission
        asset.coverBlob = dataURLtoBlob(thumbs[0]);
        
      } catch (error) {
        console.warn("Error generating video thumbnails:", error);
        asset.loadingThumbnails = false;
        asset.thumbnailsGenerated = false;
        // Keep video URL as fallback
        asset.selectedCover = url;
        asset.thumbnails = [url];
        FlashMessage("Error generating video thumbnails, using video preview", "warning");
      }
    }

    newAssets.push(asset);
    setUpdatedAssets((prev) => [...prev, { id, file }]);
  }

  // Append new assets to existing ones
  setPostMedia((prev) => [...prev, ...newAssets]);
  e.target.value = "";
};
  const handleCoverSelect = async (cover: { time: number; blob: Blob }) => {
    if (currentVideoIndex === null) return;

    try {
      // Convert blob to data URL for preview
      const dataUrl = await new Promise<string>((resolve) => {
        const reader = new FileReader();
        reader.onload = () => resolve(reader.result as string);
        reader.readAsDataURL(cover.blob);
      });

      // Update state with both the blob and data URL
      setPostMedia((prev) =>
        prev.map((asset, i) =>
          i === currentVideoIndex
            ? {
                ...asset,
                selectedCover: dataUrl,
                coverBlob: cover.blob,
              }
            : asset
        )
      );

      setShow(false);
    } catch (error) {
        FlashMessage("Failed to process cover image", "error");
    }
  };

  return (
    <>
      <Modal
        visible={open}
        title="Edit Scheduled Post"
        size="large"
        closeButton
        onClose={onClose}
        loading={loading}
        className="schedule-edit-modal"
      >
        <div className="feed-input-wrapper">
          <form onSubmit={handleSubmit(onSubmit)}>
            <div className="modal-textArea wysiwyg-data">
              <RichTextEditor
                name="content"
                control={control}
                rules={{
                  validate: {
                    validLength: (value) => {
                      const tmpText = stripHTMLTags(value || "");
                      return (
                        tmpText.length <= 3000 ||
                        "Cannot exceed more than 3000 characters"
                      );
                    },
                  },
                }}
                validationObj={errors}
                useMention
              />
                <FeedLogo
                  profileLogo={post?.post_user_image}
                  name={post?.post_user}
                  isCompany={post?.is_company}
                />
            </div>

            {errors.content && (
              <ErrorTextHelper text={errors.content.message} />
            )}

            <span className="text-length">{postTextLength}/3000</span>

            {/* Media Preview */}
            
            {postMedia?.length > 0 && (
              // <div className="feed-media-wrapper">
              <div className="feed-img-wrapper">
                {postMedia?.map((media, i) => {
                  return (
                    <div className="img-wrapper" key={i}>
                      {media.media_type === "image" ? (
                        <Image src={media?.media_thumbnail} alt="post media" />
                      ) : (
                        <>
                          {" "}
                          <ReactPlayer
                            width="100%"
                            height="100%"
                            url={media?.media_original}
                            playing={false}
                            controls={true}
                          />
                          <span
                            onClick={() => {
                              // openCoverModal(i)
                              setCurrentVideo(media.media_original);
                              setShow(true);
                              setCurrentVideoIndex(i);
                            }}
                            color="secondary"
                            className="cover-btn"
                          >
                            Edit Cover
                          </span>
                        </>
                      )}
                      <span
                        className="media-close"
                        onClick={() => removeMedia(media.id, i)}
                      >
                        {/* <DeleteIcon /> */}
                        <CancelOut />
                      </span>
                    </div>
                  );
                })}
              </div>
            )}

            {/* Media Upload and Action Buttons */}
            <div className="feed-button-wrapper">
              <FeedButton
                svg={cameraIcon}
                id="edit_scheduled_button"
                name="post_media"
                type="file"
                form={form}
                onUploadImage={onUpdateMedia}
                value="post_media"
                accept="image/png, image/gif, image/bmp, image/jpeg ,video/*"
              />
              <div className="edit-btn-wrapper">
                <Button
                  className="submit-btn"
                  loading={loading}
                  disabled={isSaveDisabled}
                  type="button"
                  onClick={handleSubmit(onSubmit)}
                >
                  Save
                </Button>
                <Button
                  className="submit-btn"
                  color="secondary"
                  onClick={onClose}
                >
                  Cancel
                </Button>
              </div>
            </div>
          </form>
        </div>
      </Modal>

      {/* Video Cover Selection Modal */}
      <CommonVideoModal
        openModal={show}
        videoUrl={currentVideo}
        onClose={() => setShow(false)}
        onCoverSelect={handleCoverSelect}
      />
    </>
  );
}
